export class MensagemDetalhesBuscaModel {
  idMsg!: string;
  contato!: string;
  dataEnvio?: Date;
  idTemplateMeta?: string;
  idUsuarioEnvio?: number;
}
